module.exports = __webpack_public_path__ + "static/media/22854204416_a0e6dee2f1_o.e7159dfd.jpg";